import { render, staticRenderFns } from "./bh-flow-item.vue?vue&type=template&id=36f1f0e9&scoped=true&lang=pug"
import script from "./bh-flow-item.vue?vue&type=script&lang=ts"
export * from "./bh-flow-item.vue?vue&type=script&lang=ts"
import style0 from "./bh-flow-item.vue?vue&type=style&index=0&id=36f1f0e9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f1f0e9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
